"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 获取当前网址
var curWwwPath = window.document.location.href;
// 获取主机地址之后的目录
var pathName = window.document.location.pathname;
var pos = curWwwPath.indexOf(pathName);
// 获取主机地址
var localhostPaht = curWwwPath.substring(0, pos);
// 获取带"/“的项目名
var projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);

// 文件服务器地址【测试库】
// const MinioIp = 'http://172.168.1.105:9000/'
// 文件服务器地址【生产库】
var MinioIp = 'https://api.sitcline.com:9001/';
// 文件服务器 bucket 名称【当前项目使用的桶】
var bucketName = 'commerce';
// FR服务器地址【测试库】
// const FRIp = 'http://172.168.1.102:8109/WebReportFR/'
// FR服务器地址【生产库】
var FRIp = 'https://api.sitcline.com/WebReport/';
var BASE_URL = localhostPaht + projectName + '/';
var MINIO_IP = MinioIp;
var MINIO_URL = MinioIp + bucketName + '/';
var FR_IP = FRIp;
var _default = exports.default = {
  BASE_URL: BASE_URL,
  MINIO_IP: MINIO_IP,
  MINIO_URL: MINIO_URL,
  FR_IP: FR_IP
};